module.exports = __webpack_public_path__ + "img/img11.e6641fdc.svg";